import axiosConfig from "./axiosConfig";

class RoleService {
    async getAll() {
        try {
            const response = await axiosConfig.get("/role");
            return response.data || [];
        } catch (error) {
            console.error("Error fetching roles:", error);
            return [];
        }
    }

    async create(formData) {
        try {
            const response = await axiosConfig.post("/role", formData);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la création:", error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }

    async update(id, formData) {
        try {
            const response = await axiosConfig.patch(`/role/${id}`, formData);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la mise à jour:", error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }

    async delete(id) {
        try {
            const response = await axiosConfig.delete(`/role/${id}`);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la suppression:", error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }
}

const RoleServiceInstance = new RoleService();
export default RoleServiceInstance;